import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MainContainer, OutlinedButton, PaperBox, SadFace, SmileGoodIcon } from '../.';
import { useEnvironment } from '../contexts';
import React from 'react';
export var AuthResult = function AuthResult() {
    var environment = useEnvironment().environment;
    var originHref = new URL(window.location.href);
    var originParams = originHref.searchParams.get('origin');
    var status = originHref.searchParams.get('status');
    var isCliOrigin = originParams === 'cli';
    var isSuccess = status === 'success';
    var originName = isCliOrigin ? 'CLI' : 'Mission Control';
    var backHome = function backHome() {
        window.location.href = environment.dashboardUrl;
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsxs(PaperBox, {
            footer: /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ _jsx(OutlinedButton, {
                    label: "Back to Home page",
                    onClick: backHome
                })
            }),
            children: [
                !!isSuccess && /*#__PURE__*/ _jsxs("div", {
                    className: "mt-8 w-full gap-4 flex flex-col",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-row items-center",
                            children: [
                                /*#__PURE__*/ _jsx(SmileGoodIcon, {}),
                                /*#__PURE__*/ _jsxs("h1", {
                                    className: "ml-2 text-white text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0",
                                    children: [
                                        "Zephyr ",
                                        originName,
                                        " Login Success!"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "font-normal text-sm text-[var(--color-secondary)] mt-2!",
                            children: [
                                "Zephyr ",
                                originName,
                                " was successfully authenticated",
                                /*#__PURE__*/ _jsx("br", {}),
                                "Now you can close this tab and return to the application."
                            ]
                        })
                    ]
                }),
                !isSuccess && /*#__PURE__*/ _jsxs("div", {
                    className: "mt-8 w-full gap-4 flex flex-row items-center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(SadFace, {}),
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: "ml-2 text-[var(--color-primary-error)] text-[32px] font-semibold leading-[38px] tracking-[-0.01562em] m-0",
                                            children: "Oooops!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "font-normal text-sm text-[var(--color-secondary)] mt-2!",
                                    children: [
                                        "Something went Wrong",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "Something unexpected happened while trying to authenticate, please try again."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: "/vectors/power-plugs-off.svg",
                            alt: "Disconnection Illustration",
                            width: "240",
                            height: "140"
                        })
                    ]
                })
            ]
        })
    });
};
